/** Search/Filter */
export enum BookingStatusType {
  Open = "Open",
  Billed = "Billed",
  Paid = "Paid",
  Closed = "Closed",
  Canceled = "Canceled"
}
